<template>
  <div
    id="kt_scrolltop"
    ref="kt_scrolltop"
    class="scrolltop"
    data-kt-scrolltop="true"
  >
    <span class="svg-icon">
      <inline-svg src="/img/navigation/up.svg" />
    </span>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { ScrollTopComponent } from '@/assets/ts/components/_ScrollTopComponent'

// Interfejs dla danych i metod komponentu
interface ScrollTopComponentInterface {
  observer: MutationObserver | null
  stEnabled: boolean
  getInstance: () => ReturnType<typeof ScrollTopComponent.getInstance>
  getState: () => boolean
}

export default defineComponent({
  name: 'ScrollTop',
  expose: ['getInstance', 'getState'],

  data() {
    return {
      observer: null,
      stEnabled: false
    } as {
      observer: MutationObserver | null
      stEnabled: boolean
    }
  },

  methods: {
    getInstance() {
      return ScrollTopComponent.getInstance(this.$refs.kt_scrolltop as HTMLElement)
    },
    getState() {
      return (this as unknown as ScrollTopComponentInterface).stEnabled
    }
  },

  mounted() {
    // Jawne określenie typu 'this'
    const self = this as unknown as ScrollTopComponentInterface

    ScrollTopComponent.reinitialization()

    self.observer = new MutationObserver(mutations => {
      for (const mt of mutations) {
        const x = mt.target as HTMLElement
        const newValue = x.getAttribute(mt.attributeName as string)

        if (mt.attributeName === 'data-kt-scrolltop') {
          self.stEnabled = newValue === 'on'
        }
      }
    })

    self.observer.observe(document.body, {
      attributes: true,
      attributeOldValue: true
    })
  }
})
</script>